/* This file is auto-generated by 'tools/data-lib-gen'. Please don't edit it manually. */
import type { CancelablePromise } from '../core/CancelablePromise';
import { request as request } from '../core/Request';
import type { RequestConfig } from '../core/Request';

export class ReactArticleService {
  /**
   * React article
   * @returns void
   * @throws ApiError
   */
  public putAtreusArticlesReact({
    articleSlug,
    requestBody
  }: {
    articleSlug: string;
    requestBody?: any;
  }): CancelablePromise<void> {
    return request(this.config, {
      method: 'PUT',
      url: '/kratos/atreus/articles/{article_slug}/react',
      path: {
        article_slug: articleSlug
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        422: `Unprocessable Entity`
      }
    });
  }

  constructor(private config?: RequestConfig) {}
}
